import { useNavigationHeaderHeight } from "../../../../TopLevelNavigators/AHNavigationHeaderContainer";

export function useStorecastHeaderLayout() {
  const headerHeight = useNavigationHeaderHeight();
  return {
    height: headerHeight,
  };
}
